import { useEffect } from "react";
import { IHeaderSetters } from "../Journal";
import './SettingsPage.css';
import { Card, Icons } from "../SharedComponents";
import React from "react";
import { GetAuthServices, IAuthServices } from "../../../Services/AuthService/AuthService";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { JournalViewModel } from "../../../ViewModel/JournalViewModel";


export function SettingsPage({ headerSetters, journalViewModel }: { journalViewModel: JournalViewModel, headerSetters: IHeaderSetters }) {

    const [auth, setAuth] = React.useState<undefined | IAuthServices>(undefined);
    const [showLogoutDialog, setShowLogoutDialog] = React.useState(false);
    const [showAccountDeleteDialog, setShowAccountDeleteDialog] = React.useState(false);

    useEffect(() => {
        headerSetters.clear();
        headerSetters.setHeaderTitle(`Settings`);
        headerSetters.setIsReadyToRender(true);

    }, [headerSetters]);

    useEffect(() => {
        (async () => {
            const auth = await GetAuthServices();
            setAuth(auth);
        })();
    }, [])

    var isFirst = true;
    const SettingRow = (props: { title: string, icon: JSX.Element, onClick?: () => void, href?: string, className?: string }) => {
        const firstClass = isFirst ? 'mt-1' : '';
        isFirst = false;
        return (
            <a className={`no-underline`} href={props.href}>
                <div className={`gl-settings-item flex flex-row align-items-center justify-content-between ${firstClass}  ${props.className}`} onClick={props.onClick}>

                    <div className="flex flex-row justify-content-start align-items-center">
                        <div className="gl-settings-item-icon m-0">{props.icon}</div>
                        <p className="gl-text-entry-typography m-0">{props.title}</p>
                    </div>
                    <Icons.ChevronRightIcon />
                </div>
            </a>
        );
    }

    const SettingsDialogue = (
        props: {
            className?: string,
            isVisible: boolean,
            setIsVisible: (isVisible: boolean) => void,
            title: string,
            children: React.ReactNode,
            buttonText: string,
            action: () => void
        }) => {
        return (
            <Dialog
                className={`SettingsConfirmationPopup gl-popup w-full`}
                visible={props.isVisible}
                dismissableMask
                resizable={false}
                maskClassName='gl-quote-mask'
                onHide={() => { if (!props.isVisible) return; props.setIsVisible(false); }}
                // breakpoints={{ '960px': '75vw', '641px': '100vw' }}
                content={({ hide }) => (
                    <div className={`gl-settings-popup`}>
                        <button
                            className='gl-close-button'
                            onClick={(e) => {
                                hide(e);
                                props.setIsVisible(false);
                            }}>
                            <Icons.CloseIcon />
                        </button>
                        <div className='gl-content-header-typography gl-header-content '>
                            <Icons.TitleIcon />
                            <p>{props.title}</p>
                        </div>
                        {props.children}
                        <div className="flex flex-row justify-content-around align-items-center">
                            <Button className={`gl-button-standard-typography gl-popup-action-button ${props.className}`} onClick={() => props.action()}>{props.buttonText}</Button>
                        </div>
                    </div>
                )}
            />
        );
    }

    return (
        <div className="gl-settings-page p-100">
            <Card noMargin disableClick className="gl-settings-card">
                <SettingRow title='Contact GrowthLenses' icon={< Icons.MailFillIcon />} href='mailto:Support@GrowthLenses.com' />
                <SettingRow title='View Tutorial' icon={<Icons.InfoIcon />} onClick={journalViewModel.TutorialState.reset} />
                {/* <SettingRow title='Change Password' icon={<Icons.LockIcon />} onClick={() => auth?.ChangePassword()} /> */}
                <SettingRow title='Log Out' icon={<Icons.LogOutIcon />} onClick={() => setShowLogoutDialog(true)} />
                <SettingRow title='Delete Account' icon={<Icons.TrashIcon />} onClick={() => setShowAccountDeleteDialog(true)} />
            </Card>
            <SettingsDialogue
                className="gl-confirm-logout"
                isVisible={showLogoutDialog}
                setIsVisible={setShowLogoutDialog}
                title="Log Out"
                action={() => auth?.LogOutUser()}
                buttonText="Log Out"
            >
                <p className="gl-popup-body-typography text-center gl-popup-body">Are you sure you want to log out?</p>
            </SettingsDialogue>
            <SettingsDialogue
                className="gl-confirm-delete-popup"
                isVisible={showAccountDeleteDialog}
                setIsVisible={setShowAccountDeleteDialog}
                title="Delete Account"
                action={() =>
                    auth?.DeleteAccount()}
                buttonText="Delete Account"
            >
                <p className="gl-popup-body-typography text-center gl-popup-body mb-0">Are you sure you want to delete your account?</p>
                <p className="gl-popup-body-typography text-center gl-popup-body mt-4">All saved information will be gone forever.</p>
            </SettingsDialogue>
        </div>
    );
}